import { useRef, useState } from "react"
import { Check, Copy } from "@phosphor-icons/react"

import { cn } from "~/utils/helpers"

interface CopyableTableProps {
  children: React.ReactNode
  compact?: boolean
}

export default function CopyableTable({ children, compact }: CopyableTableProps) {
  const tableRef = useRef<HTMLTableElement>(null)
  const [copied, setCopied] = useState(false)

  const handleCopyTable = () => {
    const table = tableRef.current
    if (!table) return
    const rows = Array.from(table.querySelectorAll("tr"))
    const tsv = rows
      .map((row) =>
        Array.from(row.querySelectorAll("th, td"))
          .map((cell) => cell.textContent?.trim() ?? "")
          .join("\t"),
      )
      .join("\n")
    navigator.clipboard.writeText(tsv)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <div className="group/table relative">
      <div
        className={cn(
          "overflow-x-auto overflow-y-hidden my-2 rounded-lg w-0 min-w-full",
          compact && "max-h-[200px] overflow-y-auto",
        )}
      >
        <table ref={tableRef} className="w-full caption-bottom text-sm">
          {children}
        </table>
      </div>
      <button
        onClick={handleCopyTable}
        className="absolute top-1 right-1 opacity-0 group-hover/table:opacity-100 transition-opacity p-1 rounded-md bg-subtle hover:bg-medium cursor-pointer"
      >
        {copied ? <Check size={12} /> : <Copy size={12} />}
      </button>
    </div>
  )
}
